var indentStyle={indentZero:"_1a6uB",indentOne:"_1Urnx",indentTwo:"dTice",indentThree:"_3OB2f",indentFour:"_2z55-",indentFive:"_3xm1r",indentSix:"eIriV"};export{indentStyle as i};
//# sourceMappingURL=indentation-a67a4a55.js.map
